import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid } from '@material-ui/core'
import Utils from '../../providers/Utils';
import ProgramatorLuniTable from '../monthComponent/ProgramatorLuniTable';
import ConcediuLuni from '../monthComponent/ConcediuLuni';
import OreLucrate from '../OreLucrate';
import Calendar from 'react-calendar';
import SpecificComponent from '../SpecificComponent';





export default class ProjectDateChange extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    fullWidth={true}
                    open={this.props.open}
                    onClose={this.props.dialogClose}>
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>
                    <Grid style={{padding:20, marginTop:50}} container>
                        <Grid style={{textAlign:'center'}} item xs={12} sm={12} md={6} lg={6} xl={6} >

                        <div style={{width:'95%'}}>

                            <span>{this.dictionary.proiecte.dateStart}</span>
                            <Calendar
                                className='pm-calendar-projects'
                                locale={this.props.dictionary.date}
                                onChange={this.props.changeDataInceput}
                                value={this.props.dtStartDate}
                            />
                               </div>
                        </Grid>
                        <Grid style={{ textAlign: 'center', }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                            <div style={{width:'95%'}}>
                            <span>{this.dictionary.proiecte.dateFinish}</span>
                            <Calendar
                                className='pm-calendar-projects'
                                locale={this.props.dictionary.date}
                                onChange={this.props.changeDataSfarsit}
                                value={this.props.dtFinishDate}
                            />
                            </div>
                          
                        </Grid>
                        <Grid style={{textAlign:'center', marginTop:20}} item xs={12} sm={12} md={12} lg={12} xl={12} className="loginButton" >
                        <Button variant="outlined" className='pm-save-button' color="primary" onClick={this.props.dialogClose}>
                           {this.props.dictionary.comune.save}
                        </Button>

                  

                    
                    </Grid>   

                    </Grid>






                </Dialog>
            </div>
        );
    }
}